'use strict';
/**
 * @module  color-interpolate
 * Pick color from palette by index
 */

require("core-js/modules/es6.array.map.js");

require("core-js/modules/es6.object.to-string.js");

require("core-js/modules/es6.array.iterator.js");

require("core-js/modules/web.dom.iterable.js");

require("core-js/modules/es6.array.slice.js");

var parse = require('color-parse');

var hsl = require('color-space/hsl');

var lerp = require('lerp');

var clamp = require('clamp');

module.exports = interpolate;

function interpolate(palette) {
  palette = palette.map(function (c) {
    c = parse(c);

    if (c.space != 'rgb') {
      if (c.space != 'hsl') throw 'c.space' + 'space is not supported.';
      c.values = hsl.rgb(c.values);
    }

    c.values.push(c.alpha);
    return c.values;
  });
  return function (t, mix) {
    mix = mix || lerp;
    t = clamp(t, 0, 1);
    var idx = (palette.length - 1) * t,
        lIdx = Math.floor(idx),
        rIdx = Math.ceil(idx);
    t = idx - lIdx;
    var lColor = palette[lIdx],
        rColor = palette[rIdx];
    var result = lColor.map(function (v, i) {
      v = mix(v, rColor[i], t);
      if (i < 3) v = Math.round(v);
      return v;
    });

    if (result[3] === 1) {
      return 'rgb(' + result.slice(0, 3) + ')';
    }

    return 'rgba(' + result + ')';
  };
}